"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sentimentToPrimaryColor = exports.horizontalAlignmentToTextAlign = void 0;
const R = __importStar(require("ramda"));
const constant_1 = require("./constant");
function horizontalAlignmentToTextAlign(alignment = constant_1.HorizontalAlignment.Center) {
    return R.propOr('center', alignment, {
        [constant_1.HorizontalAlignment.Center]: 'center',
        [constant_1.HorizontalAlignment.Left]: 'left',
        [constant_1.HorizontalAlignment.Right]: 'right',
    });
}
exports.horizontalAlignmentToTextAlign = horizontalAlignmentToTextAlign;
/**
 * Given a sentiment get its primary color.
 */
function sentimentToPrimaryColor(sentiment, theme) {
    const { Sentiment: SentimentTheme } = theme.Color;
    return R.propOr(SentimentTheme.Neutral.Primary, sentiment, {
        [constant_1.Sentiment.Action]: SentimentTheme.Action.Primary,
        [constant_1.Sentiment.Error]: SentimentTheme.Error.Primary,
        [constant_1.Sentiment.Info]: SentimentTheme.Info.Primary,
        [constant_1.Sentiment.Neutral]: SentimentTheme.Neutral.Primary,
        [constant_1.Sentiment.Success]: SentimentTheme.Success.Primary,
    });
}
exports.sentimentToPrimaryColor = sentimentToPrimaryColor;
